import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.99975 2.99975C8.25575 2.99975 8.51175 3.09775 8.70675 3.29275L16.7068 11.2928C17.0978 11.6838 17.0978 12.3158 16.7068 12.7067L8.70675 20.7067C8.31575 21.0977 7.68375 21.0977 7.29275 20.7067C6.90175 20.3157 6.90175 19.6837 7.29275 19.2927L14.5858 11.9997L7.29275 4.70675C6.90175 4.31575 6.90175 3.68375 7.29275 3.29275C7.48775 3.09775 7.74375 2.99975 7.99975 2.99975Z",
		fill: "currentColor"
	})
});
export default SvgArrowRight;
